
export const Header = {
  original_header_bg: false,
  onLoad: function() {
    HeaderDesktop.onLoad()
    this.bg_el = $('#header-bg')
    this.original_header_bg = $('#header-bg').attr('class')
    this.original_header_logo = $('#header-logo').attr('class')
    this.onNavToggle()
    SearchCreator.onLoad()
  },
  onNavToggle: function() {
    $('#mobile-nav-toggle').on('click', function () {
      if ($(this).hasClass('collapsed')) {
        Header.bg_el.attr('class', 'bg-white')
        $('#header-logo').attr('class', 'text-pink')
        $('#headerNavbar').removeClass('collapse')
        $(this).removeClass('collapsed')
        $('body').addClass('overflow-hidden')
      } else {
        Header.bg_el.attr('class', Header.original_header_bg)
        $('#header-logo').attr('class', Header.original_header_logo)
        $('#headerNavbar').addClass('collapse')
        $(this).addClass('collapsed')
        $('body').removeClass('overflow-hidden')
      }
    })
  },
}

const HeaderDesktop = {
  onLoad: function() {
    this.onResize()
    this.onScroll()
    this.toggleSticky()
  },
  onResize: function() {
    $(window).on('resize', function() {
      HeaderDesktop.toggleSticky()
    })
  },
  onScroll: function() {
    $(window).on('scroll', function() {
      HeaderDesktop.toggleSticky()
    })
  },
  toggleSticky: function() {
    const window_width = $(window).width()
    const $header_bg = $('#header-bg')
    const $body = $('body')
    let waypoint_distance_from_top = 0
    if ($('#announcement-bar-section').length) {
      waypoint_distance_from_top += $('#announcement-bar-section').height()
    }
    waypoint_distance_from_top += $('#top-navbar').height()
    if (window_width >= 968 && ($(document).scrollTop() >= waypoint_distance_from_top)) {
      $header_bg.addClass('main-header_fixed-top')
      const header_height = $header_bg.height()
      $body.css('padding-top', header_height)
      return true
    }
    if (window_width >= 968) {
      $body.css('padding-top', 'initial')
    } else {
      if ($('#headerNavbar').hasClass('collapse')) {
        HeaderDesktop.mobile_header_height = $header_bg.outerHeight()
      }
      $body.css('padding-top', HeaderDesktop.mobile_header_height)
    }
    $header_bg.removeClass('main-header_fixed-top')
  },
}

const SearchCreator = {
  search: '',
  typing_timer: null,
  onLoad: function() {
    SearchCreator.onSubmit();
    SearchCreator.onFocus();
    SearchCreator.onInput();
    SearchCreator.onDocumentClick();
  },
  onSubmit: function() {
    $('input[name="search_creators"]').on('submit', function(e) {
      e.preventDefault();
    });
  },
  onFocus: function() {
    $('input[name="search_creators"]').on('focus', function() {
      const window_width = $(window).width();
      if (window_width >= 992) {
        $('#searchCreatorsDropdown').addClass('focused');
        if ($('input[name="search_creators"]').val().length) {
          $('#searchCreatorsDropdown .dropdown-menu').addClass('show');
        }
      } else {
        $('#collapseSearchCreators').collapse('show');
      }
    });
  },
  onInput: function() {
    $('input[name="search_creators"]').on('input', function() {
      const window_width = $(window).width();
      const input_val = (window_width >= 992) ? $('input[name="search_creators"]').val() : $('#mobileNav input[name="search_creators"]').val();
      if (input_val.length) {
        if (window_width >= 992) {
          $('#searchCreatorsDropdown .dropdown-menu').addClass('show');
        } else {
          $('#collapseSearchCreators').collapse('show');
        }
        SearchCreator.showLoading();
        SearchCreator.hideResults();
        if (SearchCreator.typing_timer !== null) {
          clearTimeout(SearchCreator.typing_timer);
        }
        SearchCreator.typing_timer = setTimeout(SearchCreator.onGetCreators(), 500); // wait 0.5 seconds
      } else {
        if (window_width >= 992) {
          $('#searchCreatorsDropdown .dropdown-menu').removeClass('show');
        } else {
          $('#collapseSearchCreators').collapse('hide');
        }
      }
    });
  },
  onDocumentClick: function() {
    $(document).on('click', function(event){
      const window_width = $(window).width();
      if (window_width >= 992) {
        const $trigger = $('#searchCreatorsDropdown');
        if($trigger !== event.target && ! $trigger.has(event.target).length) {
          $('#searchCreatorsDropdown').removeClass('focused');
          $('#searchCreatorsDropdown .dropdown-menu').removeClass('show');
        }
      }
    });
  },
  showLoading: function() {
    $('.search-creators-loading').show();
  },
  hideLoading: function() {
    $('.search-creators-loading').hide();
  },
  onGetCreators: function() {
    const term = this.getSearchValue();
    const settings = {
      'url': 'https://tubularlabs.com/api/v2/autocomplete?excluded_ids=%7B%22CREATOR%22:%5B%5D%7D&term=' + term + '&types=CREATOR',
      'method': 'GET',
      'timeout': 0,
      // "headers": {
      //   "Content-Type": "",
      // },
      'processData': false,
      'mimeType': 'multipart/form-data',
      'contentType': false,
    };
    $.ajax(settings).done( function (response) {
      const responseJSON = JSON.parse(response);
      $('.search-creators-failed-response').hide();
      SearchCreator.hideLoading();
      SearchCreator.hideResults();
      const $creators = $('.search-creators-results');
      $creators.empty();
      const data = responseJSON.data;
      if (data && data.CREATOR.length) {
        data.CREATOR.forEach( (creator, key) => {
          if (key >= 5) {
            return;
          }
          const margin_bottom_class = (key !== 4) ? 'mb-3' : '';
          const $new_creator = $('<li class="creator ' + margin_bottom_class + '">\
              <div class="row">\
                <div class="col-auto">\
                  <a href="https://tubularlabs.com/creator/' + creator.id + '" title="View" target="_blank">\
                    <img src="' + creator.thumbnail + '" alt="' +  creator.title + '" class="rounded-circle" style="height: 4rem;"/>\
                  </a>\
                </div>\
                <div class="d-flex align-items-center col pl-0">\
                  <div>\
                    <p class="creator-name text-primary-blue fs-0.875x font-weight-bold mb-1">\
                      <a href="https://tubularlabs.com/creator/' + creator.id + '" title="View" target="_blank" class="text-primary-blue">' +  creator.title + '</a>\
                    </p>\
                  </div>\
                </div>\
              </div>\
            </li>');
          $creators.append($new_creator);
        });
        SearchCreator.showResults();
      } else {
        // No results
        $('.search-creators-no-results').show();
      }
    }).fail( function (err) {
      console.error(err);
      SearchCreator.hideLoading();
      $('.search-creators-failed-response').show();
    });
  },
  getSearchValue: function() {
    const window_width = $(window).width();
    return (window_width >= 992) ? $('input[name="search_creators"]').val() : $('#mobileNav input[name="search_creators"]').val();
  },
  showResults: function() {
    $('.search-creators-results').show();
  },
  hideResults: function() {
    $('.search-creators-results').hide();
  },
};



// WEBPACK FOOTER //
// ./scripts/layouts/Header.js